import { render, staticRenderFns } from "./ContactTypeIndex.vue?vue&type=template&id=01cde3ba"
import script from "./ContactTypeIndex.vue?vue&type=script&lang=js"
export * from "./ContactTypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports